import { render, staticRenderFns } from "./ReviewListPopup.vue?vue&type=template&id=2625e468&scoped=true&"
import script from "./ReviewListPopup.vue?vue&type=script&lang=js&"
export * from "./ReviewListPopup.vue?vue&type=script&lang=js&"
import style0 from "./ReviewListPopup.vue?vue&type=style&index=0&id=2625e468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2625e468",
  null
  
)

export default component.exports